import { HttpClient } from '../api/client'
import type { ApiResponse, MindMapNode, MindMapEdge } from '@bandos/shared'
import type { FeedbackContext } from '../../context/ScopedChatContext'
import { getAuthenticatedHeaders } from './aiHelpers'
import type { ChatContext } from './aiTypes'

/**
 * AI chat service for stakeholder conversations.
 */
export class AIChatService {
  /** Send a chat message to the AI assistant */
  static async sendChatMessage(
    mindmapId: string,
    message: string,
    stakeholderId?: string,
    context?: ChatContext,
    feedbackContext?: FeedbackContext
  ): Promise<ApiResponse<{ response: string; nodes?: MindMapNode[]; edges?: MindMapEdge[] }>> {
    const auth = await getAuthenticatedHeaders<{
      response: string
      nodes?: MindMapNode[]
      edges?: MindMapEdge[]
    }>()
    if (auth.error) return auth.error

    const requestData = {
      mindmapId,
      message,
      ...(stakeholderId && { stakeholderId }),
      context,
      ...(feedbackContext && { feedbackContext }),
    }

    return HttpClient.post<{ response: string; nodes?: MindMapNode[]; edges?: MindMapEdge[] }>(
      '/ai/chat',
      requestData,
      auth.headers
    )
  }
}
